import * as React from 'react';

interface FormContextProps {
	formData: { [key: string]: string };
	handleChange: (id: string, value: string) => void;
	setFormData: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
	errors: { [key: string]: string | boolean };
	setErrors: React.Dispatch<React.SetStateAction<{ [key: string]: string | boolean }>>;
	loading: boolean;
	setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const FormContext = React.createContext<FormContextProps | undefined>(undefined);

export const useFormContext = () => {
	const context = React.useContext(FormContext);
	if (!context) {
		throw new Error('useFormContext must be used within a FormProvider');
	}
	return context;
};

export const FormProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [formData, setFormData] = React.useState<{ [key: string]: string }>({});
	const [errors, setErrors] = React.useState<{ [key: string]: string | boolean }>({});
	const [loading, setLoading] = React.useState<boolean>(false);

	const handleChange = (id: string, value: string) => {
		setFormData((prevData) => ({
			...prevData,
			[id]: value,
		}));
	};

	return (
		<FormContext.Provider
			value={{ formData, handleChange, setFormData, errors, setErrors, loading, setLoading }}
		>
			{children}
		</FormContext.Provider>
	);
};
